<div class="modal-body" id="chooseCompanyModal">
  <form [formGroup]="formGroup">
    @if (!isUserExternal) {
      <div class="form-group">
        <label for="roleFriendlyName">Report Type</label>
        <div class="input-group">
          <select
            class="custom-select form-control"
            formControlName="roleFriendlyName"
            id="reportTypeModal"
            (change)="handleRoleChange()"
          >
            >
            @for (option of roles; track option) {
              <option [ngValue]="option">
                {{ option }}
              </option>
            }
          </select>
          @if (isLoadingRole) {
            <div class="input-group-append spinner">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
    <div class="form-group">
      <label for="parentCustomerId">Company</label>
      @if (!isUserExternal) {
        <div class="input-group">
          <div class="input-with-icon-left">
            <input
              id="parentCustomerModal"
              [(ngModel)]="selectedNameWithCount"
              [ngModelOptions]="{ standalone: true }"
              [typeahead]="parentCustomers"
              typeaheadOptionField="nameWithCount"
              [typeaheadMinLength]="0"
              [typeaheadOptionsLimit]="100"
              (typeaheadOnSelect)="handleParentChange($event.item)"
              class="form-control"
              placeholder="Select a Customer..."
              autocomplete="off"
            />
            <div class="input-icon">
              <em class="modus-icon material-icons">search</em>
            </div>
          </div>
          @if (!isLoadingParent) {
            <div class="input-group-append">
              <button class="btn btn-icon-only btn-tertiary" id="clearButton" (click)="clearParent()">
                <em class="modus-icon material-icons">close</em>
              </button>
            </div>
          }
          @if (isLoadingParent) {
            <div class="input-group-append spinner">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          }
        </div>
      }
      @if (isUserExternal) {
        <div class="input-group">
          {{ user.customerCName }}
        </div>
      }
    </div>
    <div class="form-group">
      <label for="childCustomerId">Affiliate</label>
      <div class="input-group">
        <select class="custom-select form-control" formControlName="childCustomerId" id="childCustomerId">
          @for (option of childCustomers; track option) {
            <option [ngValue]="$safeNavigationMigration(option?.id)">
              {{ option?.nameWithCount }}
            </option>
          }
        </select>
        @if (isLoadingChild) {
          <div class="input-group-append spinner">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        }
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" id="chooseCompanyCancel" (click)="close(true)">Cancel</button>
  <button
    type="button"
    class="btn btn-primary"
    id="chooseCompanySaveButton"
    [disabled]="!isDirty() || !isValid() || isLoading"
    (click)="save()"
  >
    Choose Company
  </button>
</div>
